export enum VgStates {
	PAUSE = 'pause',
	PLAY = 'play',
	STOP = 'stop'
}
